export default "__VITE_ASSET__Bs2Z3mQK__"